export const SHAKE_SALAD_API: string = process.env.REACT_APP_API_BASE_URL as string;
export const SHAKE_HQ_APP: string = process.env.REACT_APP_SHAKE_HQ_APP as string;
export const SHAKE_HQ_API_KEY: string = process.env.REACT_APP_SHAKE_HQ_API_KEY as string;
export const SHAKE_HQ_CUSTOMER_SEND_PATH = '/api/customer/send';
export const API_GET_MENU_BY_MACHINE_SLUG = '/api/publicCatalog/get_by_machine_slug';